import React from "react";

const MainObjectives = ({ register, name='main_objectives' }) => {
  // main_objectives
  return (
    <div className="mt-5">
     
      {/* text area */}
      <div className="mt-3">
        <textarea
          name=""
          {...register(name, {
            required: false,
          })}
          className="border-primary-blue outline-none text-primary-blue w-full border-2 p-3"
          id=""
          cols={30}
          rows={10}
          defaultValue={""}
        />
      </div>
    </div>
  );
};

export default MainObjectives;
